import Utils from '@/lin/util/util'
import homeConfig from './home' //引入模块
import errorConfig from './error' //引入模块
import personalConfig from './personal' //引入模块
// import adminConfig from './admin' //引入模块

let homeRouter = JSON.parse(window.localStorage.getItem('tokensss')) || []

// 接入插件
const plugins = [homeConfig, personalConfig, errorConfig]
// filterPlugin(menuTree.homeRouter)
homeRouter = plugins.concat(homeRouter)
// window.onload = function () {}
homeRouter = Utils.sortByOrder(homeRouter)
deepReduceName(homeRouter)

// 处理顺序
export default homeRouter

/**
 * 筛除已经被添加的插件
 */
// function filterPlugin(data) {
//   if (plugins.length === 0) {
//     return
//   }
//   if (Array.isArray(data)) {
//     data.forEach(item => {
//       filterPlugin(item)
//     })
//   } else {
//     const findResult = plugins.findIndex(item => data === item)
//     if (findResult >= 0) {
//       plugins.splice(findResult, 1)
//     }
//     if (data.children) {
//       filterPlugin(data.children)
//     }
//   }
// }

/**
 * 使用 Symbol 处理 name 字段, 保证唯一性
 */
function deepReduceName(target) {
  if (Array.isArray(target)) {
    target.forEach(item => {
      if (typeof item !== 'object') {
        return
      }
      deepReduceName(item)
    })
    return
  }
  if (typeof target === 'object') {
    if (typeof target.name !== 'symbol') {
      target.name = target.name || (target.route ? Utils.setSymbolName(target.route) : target.title)
      target.name = Symbol(target.name)
    }

    if (Array.isArray(target.children)) {
      target.children.forEach(item => {
        if (typeof item !== 'object') {
          return
        }
        deepReduceName(item)
      })
    }
  }
}
